import React from 'react';

const Contact = () => {
  return (
    <section className="about-section py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Texto primero en HTML, pero se mostrará primero solo en pantallas grandes */}
          <div className="col-lg-6 order-lg-1 order-2">
            <h2 className="section-title mb-4">
              <em>Contactanos</em>
            </h2>
            
            <div className="founders-story">
                <p className="lead highlight-text bold">
                Para consultas, entrevistas o coordinación de defensa legal,
                puede comunicarse a través de nuestro formulario de contacto o por vía telefónica. Atendemos urgencias penales y ofrecemos entrevistas iniciales confidenciales.
                </p>
                <div className="consultas-container">
                    <a
                        href="https://wa.me/5493513921660?text=Hola%2C%20quisiera%20hacer%20una%20consulta%20legal."
                        target="_blank"
                        rel="noopener noreferrer"
                        className="consultas-button"
                    >
                    <img src="/images/Whatsapp.png" alt="WhatsApp" className="whatsapp-icon" />
                    Consultas
                    </a>
                </div>
            </div>
          </div>

          {/* Imagen segundo en HTML, pero se mostrará segundo solo en pantallas grandes */}
          <div className="col-lg-6 order-lg-2 order-1 mb-4 mb-lg-0">
            <div className="founders-image-container">
              <img 
                src="/images/IMG_2190.jpg" 
                alt="Gastón Córdoba" 
                className="founders-image img-fluid rounded-3"
              />
              

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
